import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import Keypad from './Keypad';
import TransactionKey from './TransactionKey';
import CashbackKey from './CashbackKey';
import { UserConsumer } from '../context/ThemeContext';
import Result from './Result';
import { Redirect } from 'react-router-dom';
import { transaction, reversal, refund, cashbackTransaction } from '../services/transactionService';
// import TransactionConfirmModal from './TransactionConfirmModal';
import TransactionSuccess from './TransactionSucess';
import { SettingContext } from '../context/SettingContext';
import CurrencyISO from '../mockdata/currencyISO.json';
import APIProgress from './APIProgress';
import ErrorModal from './ErrorModal';
import '../stylesheets/Home.css';

class Transaction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTerminal: props.history.location.state ? props.history.location.state.selectedTerminal : '',
            pinBypass: false,
            showModal: false,
            showError: false,
            apiProgress: false,
            apiResult: '',
            errorDesc: '',
            apiProgressText: '',
            result: 0,
            convertedResult: 0,
            cbMode: false,
            cbResult: 0,
            convertedCbResult: 0,
            operatorMode: false,
            operatorID: localStorage.operatorId ? localStorage.operatorId : ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handlePinBypass = this.handlePinBypass.bind(this);
        this.toggleCbMode = this.toggleCbMode.bind(this);
        this.toggleOperatorMode = this.toggleOperatorMode.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.selectedCurreny = localStorage.currency ? localStorage.getItem('currency') : 'Euro';
    }

    componentDidMount() {
        this.setResult(0);
        this.setCbResult(0);
    }

    setResult(amount) {
        let formattedValue = this.formatFunction(amount);
        this.setState({
            result: amount,
            convertedResult: formattedValue
        });
    }
    setCbResult(amount) {
        let formattedValue = this.formatFunction(amount);
        this.setState({
            cbResult: amount,
            convertedCbResult: formattedValue
        });
    }

    closeError = () => {
        this.setState({
            showError: false
        }, this.state.errorDesc === 'Timeout' ? window.location.reload(false) : null);
    }

    showProgressModal = (apiResult) => {
        this.setState({
            apiProgress: false,
            apiResult: apiResult,
            showModal: true
        }, () => { this.resetResultState(); });
    }

    showErrorModal = (errorDesc) => {
        this.setState({
            apiProgress: false,
            errorDesc: errorDesc,
            showError: true
        }, () => { this.resetResultState(); });
    }

    handleApiResponse = result => {

        if (result.status === 201) {
            if (result.data.result[0]) {
                this.showProgressModal(result.data.result[0]);
            } else {
                this.showErrorModal('SomethingWrong');
            }
        }
        else {
            if (result.message === 'Network Error') {
                this.showErrorModal('NetworkError');
            }
            else if (result.response.status === 401 || result.response.status === 504) {
                this.showErrorModal('Timeout');
            }
            else {
                !Object.keys(result.response.data.failure).length ?
                    this.showErrorModal('TerminalConnection')
                    :
                    result.response.data.failure ?
                        this.showErrorModal(result.response.data.failure.localModeEventArgs ?
                            result.response.data.failure.localModeEventArgs.rejectionReason :
                            'TerminalConnection')
                        :
                        this.showErrorModal('SomethingWrong');
            }
        }
    }

    onMoreClick = () => {
        this.setState({
            showMoreOption: !this.state.showMoreOption
        });
    }

    cbClick = () => {
        this.setState({
            apiProgress: true,
            apiProgressText: 'Cashback'
        });
        cashbackTransaction(this.state.result, this.state.cbResult, !this.state.pinBypass, this.state.selectedTerminal).then(result =>

            this.handleApiResponse(result)

        );
    }

    transactionClick = (button) => {
        if (button === 'Purchase') {
            this.setState({
                apiProgress: true,
                apiProgressText: button
            });
            transaction('purchase', this.state.result, !this.state.pinBypass, this.state.selectedTerminal).then(result => {
                this.handleApiResponse(result);
            });
        }
        else if (button === 'Reversal') {
            this.setState({
                apiProgress: true,
                apiProgressText: button
            });
            reversal('reversal', this.state.result, !this.state.pinBypass, this.state.selectedTerminal).then(result => {
                this.handleApiResponse(result);
            });
        }
        else if (button === 'Refund') {
            this.setState({
                apiProgress: true,
                apiProgressText: button
            });
            refund(this.state.result, this.state.selectedTerminal).then(result => {
                this.handleApiResponse(result);
            });
        }
    }

    onClick = button => {

        if (button === 'C') {

            if (this.state.operatorMode) {
                this.setState({ operatorID: '' });
            } else {
                this.setResultState(0, 0);
            }

        }
        else if (button === 'bksp') {

            if (this.state.operatorMode) {
                this.setState(prevState => ({ operatorID: prevState.operatorID.slice(0, -1) }));
            } else {
                if (this.state.cbMode) {
                    this.setCbResult(this.state.cbResult.slice(0, -1));
                } else {
                    this.setResult(this.state.result.slice(0, -1));
                }
            }

        }
        else {

            if (this.state.operatorMode) {

                if (this.state.operatorID.length < 4) {
                    this.setState(prevState => ({ operatorID: prevState.operatorID.concat(button) }));
                } else if (this.state.operatorID.length >= 4 && (parseInt(this.state.operatorID) * 1) !== 0) {
                    this.setState({ operatorMode: !this.state.operatorMode });
                } else {
                    return null;
                }

            } else {

                if (this.state.cbMode) {
                    if (this.state.cbResult === 0) {
                        this.setCbResult(button);
                    } else {
                        if (this.state.cbResult.length < 9) {
                            this.setCbResult(this.state.cbResult + button);
                        } else {
                            return null;
                        }
                    }

                } else {

                    if (this.state.result === 0) {
                        this.setResult(button);
                    } else {
                        if (this.state.result.length < 9) {
                            this.setResult(this.state.result + button);
                        } else {
                            return null;
                        }
                    }

                }

            }

        }
    };

    setResultState = (result, cbResult) => {

        if (result.length < 9 || result === 0 || cbResult.length < 9 || cbResult === 0) {
            if (this.state.cbMode) {
                this.setCbResult(cbResult);
            } else {
                this.setResult(result);
            }
        } else
            return null;

    };
    resetResultState = () => {
        this.setCbResult(0);
        this.setResult(0);
        this.setState({
            cbMode: false,
            pinBypass: false
        });
    }

    formatFunction = (value) => {
        var formatter = new Intl.NumberFormat(CurrencyISO[this.selectedCurreny].language + '-' + CurrencyISO[this.selectedCurreny].Country, {
            style: 'currency',
            currency: CurrencyISO[this.selectedCurreny].Currency,
        });
        var nn = value;
        nn = (nn / 100);
        nn = nn.toFixed(2);
        nn = formatter.format(nn);
        return nn;
    }

    closeModal = () => {
        this.setState({
            showModal: false
        });
    }

    handleKeyPress(event) {
        var key = event.keyCode || event.charCode;
        if (key === 8 || key === 46 || key === 188 || key === 110 || key === 190) {
            this.setResultState(0, 0);
        }
    }

    handleChange(event) {
        let cleanValue = event.target.value.replace(/[^0-9]+/g, '');
        this.setResultState(cleanValue, cleanValue);
    }

    handlePinBypass() {
        this.setState({
            pinBypass: !this.state.pinBypass
        });
    }

    toggleCbMode() {
        this.setState({
            cbMode: !this.state.cbMode
        });
    }

    toggleOperatorMode() {
        this.setState({
            operatorMode: !this.state.operatorMode
        },
            this.state.operatorMode ?
                localStorage.setItem('operatorId', this.state.operatorID === '' ? '0000' : this.state.operatorID)
                : null
        );
    }

    render() {

        if (this.state.selectedTerminal === '') {
            return <Redirect to="/" />;
        }
        return (
            <SettingContext.Consumer>{(settingContext) => (
                <UserConsumer>
                    {themeProp => {
                        const { currency, translatedContent } = settingContext;
                        return (
                            <>
                                {this.state.showModal ?
                                    <TransactionSuccess show={this.state.showModal} buttonText={translatedContent.DialogueBox} result={this.state.apiResult} closeModal={this.closeModal} isMobile={themeProp.dimensions.isMobile} />
                                    : null}
                                {this.state.showError ?
                                    <ErrorModal show={this.state.showError} translate={translatedContent.ErrorCode} errorDesc={this.state.errorDesc} closeError={this.closeError} isMobile={themeProp.dimensions.isMobile} />
                                    : null}
                                {this.state.apiProgress ?
                                    <APIProgress progressText={translatedContent.ProgressText[this.state.apiProgressText]} terminalID={this.state.selectedTerminal} show={this.state.apiProgress} />
                                    : null}
                                <Row className="mt-4">
                                    <Col md={{ span: 4, offset: 4 }} >
                                        <Card className="text-center">
                                            <Card.Body>
                                                <Card.Title>{translatedContent.OperationsFor + ' \'' + this.state.selectedTerminal + '\' '} </Card.Title>
                                                <Form.Check inline className="align-with-subtitle" aria-label="option 1" checked={this.state.operatorMode} onChange={this.toggleOperatorMode} />
                                                <Card.Subtitle className="mb-2 text-muted align-with-subtitle">Operator ID: {this.state.operatorID.length === 0 ? '0000' : this.state.operatorID}</Card.Subtitle>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="justify-content-md-center">
                                    <Col xs sm md="2" lg="2">
                                        <Form.Group className="text-left" controlId="formBasicChecbox">
                                            <Form.Check
                                                type="checkbox"
                                                disabled={this.state.result === '' || (parseInt(this.state.result) * 1) === 0}
                                                label={translatedContent.ToggleCashback}
                                                id="CashBackMode"
                                                checked={this.state.cbMode}
                                                onChange={this.toggleCbMode} />
                                        </Form.Group>
                                    </Col>
                                    <Col xs sm md="2" lg="2">
                                        <Form.Group className="text-right" controlId="formBasicChecbox">
                                            <Form.Check
                                                type="checkbox"
                                                label={translatedContent.BypassPin}
                                                id="allowPinBypass"
                                                checked={this.state.pinBypass}
                                                onChange={this.handlePinBypass} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {/* <Row className="mt-1">
                                    <Col md={{ span: 4, offset: 4 }} >
                                        <Row className="text-center mt-3">
                                            <Col>
                                                <Form.Group className="text-left" controlId="formBasicChecbox">
                                                    <Form.Check
                                                        type="checkbox"
                                                        disabled={this.state.result === '' || (parseInt(this.state.result) * 1) === 0}
                                                        label={translatedContent.ToggleCashback}
                                                        id="CashBackMode"
                                                        checked={this.state.cbMode}
                                                        onChange={this.toggleCbMode} />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="text-left" controlId="formBasicChecbox">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Set Operator"
                                                        id="OperatorMode"
                                                        checked={this.state.operatorMode}
                                                        onChange={this.toggleOperatorMode} />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="text-right" controlId="formBasicChecbox">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label={translatedContent.BypassPin}
                                                        id="allowPinBypass"
                                                        checked={this.state.pinBypass}
                                                        onChange={this.handlePinBypass} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row> */}
                                <Row className="mt-1">
                                    <Col md={{ span: 4, offset: 4 }} >
                                        {
                                            this.state.operatorMode ?
                                                <Keypad result={this.state.operatorID} mode="operator" onClick={this.onClick} isMobile={themeProp.dimensions.isMobile} />
                                                :
                                                this.state.cbMode ?
                                                    <>
                                                        <Result result={this.state.cbResult} convertedResult={this.state.convertedCbResult} handleKeyPress={this.handleKeyPress.bind(this)} currency={currency} isMobile={themeProp.dimensions.isMobile} handleChange={this.handleChange.bind(this)} />
                                                        <Keypad result={this.state.cbResult} mode="cashback" onClick={this.onClick} isMobile={themeProp.dimensions.isMobile} />
                                                        <CashbackKey result={this.state.result} cbResult={this.state.cbResult} onClick={this.cbClick} KeyValue={translatedContent.TransactionKey} isMobile={themeProp.dimensions.isMobile} />
                                                    </>
                                                    :
                                                    <>
                                                        <Result result={this.state.result} convertedResult={this.state.convertedResult} handleKeyPress={this.handleKeyPress.bind(this)} currency={currency} isMobile={themeProp.dimensions.isMobile} handleChange={this.handleChange.bind(this)} />
                                                        <Keypad result={this.state.result} mode="transaction" onClick={this.onClick} isMobile={themeProp.dimensions.isMobile} />
                                                        <TransactionKey result={this.state.result} onClick={this.transactionClick} KeyValue={translatedContent.TransactionKey} isMobile={themeProp.dimensions.isMobile} OperatorID={this.state.operatorID} />
                                                    </>
                                        }
                                    </Col>
                                </Row>
                            </>
                        );
                    }}
                </UserConsumer>
            )}
            </SettingContext.Consumer>
        );
    }
}

export default Transaction;